// libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Actions
import modalActions from '../../../../actions/modal';

// Component
import ImageModal from '../../../singles/activity/parts/imageModal/ImageModal';

function Gallery(props) {
  const {
    images,
    showModal,
  } = props;
  return (
    <div className="flexible-content__item">
      {images &&
      <ul className="flexible-content__gallery">
        {images.map((image) =>
          <li key={`${image.name}-${image.ID}`}>
            <button
              className="flexible-content__gallery__item"
              onClick={() => showModal(
                ImageModal,
                {
                  mediaUrl: image.sizes.large,
                  alt: image.alt,
                  description: image.description,
                },
              )}
            >
              <span />
              <img
                src={image.sizes.large}
                alt={image.alt}
              />
            </button>
          </li>,
        )}
      </ul>
      }
    </div>
  );
}

function mapStateToProps(state) {
  return {
    modalIsVisible: state.modal.isVisible,
    pagesList: state.pages.pagesList,
  };
}

Gallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.object).isRequired,
  showModal: PropTypes.func.isRequired,
};

export default withRouter(connect(
  mapStateToProps,
  { ...modalActions },
)(Gallery));



// WEBPACK FOOTER //
// ./src/app/components/pages/default/flexibleContents/Gallery.js